export default {
  /**
       * Node to attach the drawer root component
      */
  appendTo: {
    type: [String, HTMLElement],
  },
  /**
       * Determined which side the drawer opens from.
       */
  side: {
    type: String,
    default: 'right',
    validator: (val) => val.match(/(left|right)/),
  },
  /**
       * Boolean that determines whether or not to show the drawer
       */
  active: {
    type: Boolean,
    required: true,
  },
  closeVariation: {
    type: String,
    default: 'back',
    validator: (val) => val.match(/(back|x)/),
  },
  closeOnOutsideClick: {
    type: Boolean,
    default: () => true,
  },
  /**
       * Function to bypass the default mount function on component mount
       */
  initOverrides: {
    type: Function,
    default: null,
  },
  /**
       * Function to bypass the default unmount function on component unmount
       */
  destroyOverrides: {
    type: Function,
    default: null,
  },
  /**
       * Boolean to remove padding and margin from container.
       */
  removePadding: {
    type: Boolean,
    default: false,
  },
  /**
       * Class applied to the root container of the drawer (excluding mask)
       */
  containerClass: {
    type: String,
  },
};
